import React, { useEffect, useRef, useState } from "react";
import { Link, useRouteMatch } from "react-router-dom";

import { Button, Col, Divider, Dropdown, Icon, Input, Menu, message, Modal, Row, Table, Typography, Upload, Select } from "antd";
import { ReactComponent as StoreLogo } from "./Store.svg";
import Loader from "components/Loader/Loader";

import "./Stores.css";
// .ant-upload.ant-upload-select-picture-card {
//   display: none;
// }
import { updateStoreApi, featchAllStoresApi, AddStoreApi, getAddress, getLanguagesApi, updateStoreDetailApi } from "utils/apiService";
import { countries } from "constants/CountryList";
import { handelChange } from "actions/channelProduct";
import ReactCountryFlag from "react-country-flag";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import arrayMove from 'array-move';
import isDev from "server";
import axios from "axios";

const serverUrl = isDev();
const { Text } = Typography;
const { Dragger } = Upload;
const { Option } = Select;
export function getCountryFlag(countryName) {
	var countryCode = countries.find((data) => data.name === countryName)?.shortName;
	return countryCode;
}

const formValidation = (storeDetails, storelocation, StoreImageFile) => {
	const { address, city, country, region, latitude, longitude } = storelocation;
	const { name } = storeDetails;
	// console.log(storeDetails);
	let isNumber = /[+-]?([0-9]*[.])?[0-9]+/;
	for (var key of Object.keys(storelocation)) {
		if (storeDetails[key] == "") {
			message.error(`${key} is required`);
			return false;
		}
	}
	if (name === "") {
		message.error(`Store Name is required`);
		return false;
	}
	if (StoreImageFile === null) {
		message.error(`Store Image is required`);
		return false;
	}
	if (isNumber.test(longitude) === false) {
		message.error(`Longitute must be number`);
		return false;
	}
	if (isNumber.test(latitude) === false) {
		message.error(`Latitude must be number`);
		return false;
	}
	return true;
};

const updateStore = async (storeDetails, setStoreDeatils, storelocation, StoreImageFile, setUpdateModal, loadTable, storeMainDetails) => {
	// console.log(storeDetails);
	if (!formValidation(storeDetails, storelocation, StoreImageFile)) {
		return;
	}
	const body = new FormData();
	// debugger;

	// setStoreDeatils({
	// 	...storeDetails,
	// 	location: JSON.stringify(storelocation),
	// });
	for (var key of Object.keys(storeMainDetails)) {
		if (storeMainDetails[key] != "") body.append(key, storeMainDetails[key]);
	}
	body.append("permission_category", JSON.stringify(["STORE_CONTROL_CENTER"]));
	if (StoreImageFile != null || StoreImageFile != "") body.append("image", StoreImageFile);

	updateStoreApi({
		requestData: body,
		resCallback: () => { },
		res200Callback: () => {
			updateStoreDetailApi({
				requestData: storeDetails,
				resCallback: () => { },
				res200Callback: () => {
					message.success("Store updated successfully.");
					loadTable();
					setUpdateModal(false);
					// setaddModal(false);
					// return;
				},
				resErrorCallback: () => {
					message.error("Failed updating the store details!");
				},
			});
			// message.success("Store updated successfully.");

			// loadTable();
			// setUpdateModal(false);
			// setaddModal(false);
			// return;
		},
		resErrorCallback: () => {
			message.error("Failed updating the store !");
		},
	});
};

const StoresTable = (props) => {
	// debugger;
	const { data } = props;
	const [stores, setStores] = useState([])
	const [StoreImageFile, setStoreImageFile] = useState(null);
	const [languagesData, setLanguagesData] = useState([]);

	const [previewDetails, setpreviewDetails] = useState({
		uid: "",
		status: "",
		url: "",
		// name:""
	});
	const [selectedLanguage, setSelectedLanguage] = useState("English")
	const [storeDetails, setStoreDeatils] = useState({
		uuid: "",
		// name: "",
		store_details: "",
		// location: "",
		// company_code: "",
		// sap_code: "",
		// language: "",
	});

	const [storeMainDetails, setStoreMainDeatils] = useState({
		uuid: "",
		// name: "",
		// location: "",
		company_code: "",
		sap_code: "",
		language: "",
	});

	const [storelocation, setStorelocation] = useState({
		latitude: "",
		longitude: "",
		region: "",
		city: "",
		country: "",
		address: "",
	});

	const [disableStore, setdisableStore] = useState(false);

	const [updateModal, setUpdateModal] = useState(false);
	const updateCohort = useRef({
		name: "",
		uuid: "",
	});

	const [disableModal, setDisableModal] = useState(false);
	const [activeIndex, setActiveIndex] = useState(0);

	const getlocation = (locObj) => {
		// storelocation.latitude &&
		// 	storelocation.longitude &&
		locObj.latitude &&
			locObj.longitude &&
			getAddress(locObj.latitude, locObj.longitude).then((address) => {
				// setStorelocation({
				// 	...storelocation,
				// 	["region"]: address.state || address.country || "",
				// 	["city"]: address.city || storelocation.city,
				// 	["country"]: address.countryName || storelocation.country,
				// });
				let loc = {
					...locObj,
					["region"]: address.state || address.county || "",
					["city"]: address.city || storelocation.city,
					["country"]: address.countryName || locObj.country,
				}
				setLanguageSpecificStoreInfo("location", loc)
			});
	}

	const setLanguageSpecificStoreInfo = (key, value) => {
		let storeSubDeatils = {
			...storeDetails?.store_details[selectedLanguage],
			[key]: value,
		}
		let languageSpecificStoreDetails = {
			...storeDetails?.store_details,
			[selectedLanguage]: {
				...storeSubDeatils
			}
		}
		setStoreDeatils({
			...storeDetails,
			["store_details"]: languageSpecificStoreDetails
		});
	}

	const setLanguageSpecificStoreLocation = (key, value) => {
		let storeLocationObj = {
			...storeDetails?.store_details[selectedLanguage].location,
			[key]: value,
		}
		let storeSubDeatils = {
			...storeDetails?.store_details[selectedLanguage],
			["location"]: storeLocationObj,
		}
		let languageSpecificStoreDetails = {
			...storeDetails?.store_details,
			[selectedLanguage]: {
				...storeSubDeatils
			}
		}
		setStoreDeatils({
			...storeDetails,
			["store_details"]: languageSpecificStoreDetails
		});
	}

	useEffect(() => {
		getLanguagesApi({
			requestData: {

			},
			res200Callback: (res) => {
				setLanguagesData(res.data.languages);
			},
		});
	}, []);

	// useEffect(() => {
	// 	setStoreDeatils({
	// 		...storeDetails,
	// 		location: JSON.stringify(storelocation),
	// 	});
	// }, [storelocation]);

	useEffect(() => {
		setStores(
			data?.stores
		);
	}, [data?.stores]);

	// const columns = [
	// 	{
	// 		title: "Store Name",
	// 		dataIndex: ["name", "image", "location"],
	// 		key: "storeName",
	// 		render: (_, data) => {
	// 			// console.log(data);
	// 			// di
	// 			return (
	// 				<div
	// 					style={{
	// 						// width: "300px",
	// 						display: "flex",
	// 						//   justifyContent: "center",
	// 						marginRight: "0px",
	// 					}}>
	// 					<img
	// 						style={{
	// 							height: "70px",
	// 							width: "70px",
	// 							borderRadius: "10px",
	// 							marginRight: "15px",
	// 						}}
	// 						src={data?.image?.url}></img>
	// 					<div
	// 						style={{
	// 							display: "flex",
	// 							flexDirection: "column",
	// 							justifyContent: "center",
	// 						}}>
	// 						<Text
	// 							style={{
	// 								fontStyle: "normal",
	// 								fontWeight: "bold",
	// 								fontSize: "16px",
	// 								lineHeight: "24px",
	// 								color: "#181818",
	// 								// whiteSpace: "nowrap",
	// 								//   overflow: "scroll",
	// 							}}>
	// 							{data?.name}
	// 						</Text>
	// 						<Text>{data?.location?.address}</Text>
	// 					</div>
	// 				</div>
	// 			);
	// 		},
	// 	},
	// 	{
	// 		title: "Company Code",
	// 		dataIndex: "company_code",
	// 		key: "company_code",
	// 		render: (data) => {
	// 			return (
	// 				<Text
	// 					style={{
	// 						//   fontStyle: "normal",
	// 						//   fontWeight: "bold",
	// 						//   fontSize: "16px",
	// 						//   lineHeight: "24px",
	// 						//   color: "#181818",
	// 						whiteSpace: "nowrap",
	// 					}}>
	// 					{data}
	// 				</Text>
	// 			);
	// 		},
	// 	},
	// 	{
	// 		title: "Sap Code",
	// 		dataIndex: "sap_code",
	// 		key: "sap_code",
	// 		render: (data) => {
	// 			return (
	// 				<Text
	// 					style={{
	// 						//   fontStyle: "normal",
	// 						//   fontWeight: "bold",
	// 						//   fontSize: "16px",
	// 						//   lineHeight: "24px",
	// 						//   color: "#181818",
	// 						whiteSpace: "nowrap",
	// 					}}>
	// 					{data}
	// 				</Text>
	// 			);
	// 		},
	// 	},
	// 	{
	// 		title: "City",
	// 		dataIndex: "location",
	// 		key: "city",
	// 		render: (data) => {
	// 			return (
	// 				<Text
	// 					style={{
	// 						//   fontStyle: "normal",
	// 						//   fontWeight: "bold",
	// 						//   fontSize: "16px",
	// 						//   lineHeight: "24px",
	// 						//   color: "#181818",
	// 						whiteSpace: "nowrap",
	// 					}}>
	// 					{data?.city}
	// 				</Text>
	// 			);
	// 		},
	// 	},
	// 	{
	// 		title: "State/Region/Emirate",
	// 		dataIndex: "location",
	// 		key: "region",
	// 		render: (data) => {
	// 			return (
	// 				<Text
	// 					style={{
	// 						//   fontStyle: "normal",
	// 						//   fontWeight: "bold",
	// 						//   fontSize: "16px",
	// 						//   lineHeight: "24px",
	// 						//   color: "#181818",
	// 						whiteSpace: "nowrap",
	// 					}}>
	// 					{data?.region}
	// 				</Text>
	// 			);
	// 		},
	// 	},
	// 	{
	// 		title: "Country",
	// 		dataIndex: "location",
	// 		key: "country",
	// 		render: (data) => {
	// 			return (
	// 				<div>
	// 					<ReactCountryFlag
	// 						countryCode={getCountryFlag(data.country || JSON.parse(localStorage.getItem("countryData")).country_name)}
	// 						svg
	// 						title={data.country || localStorage.getItem("countryData").country_name}
	// 						style={{
	// 							height: "23px",
	// 							width: "23px",
	// 							borderRadius: "20px",
	// 							backgroundColor: "black",
	// 							objectFit: "cover",
	// 							marginRight: "5px",
	// 						}}
	// 					/>
	// 					<Text
	// 						style={{
	// 							//   fontStyle: "normal",
	// 							//   fontWeight: "bold",
	// 							//   fontSize: "16px",
	// 							//   lineHeight: "24px",
	// 							//   color: "#181818",
	// 							whiteSpace: "nowrap",
	// 						}}>
	// 						{data.country || JSON.parse(localStorage.getItem("countryData")).country_name}
	// 					</Text>
	// 				</div>
	// 			);
	// 		},
	// 	},
	// 	{
	// 		title: "",
	// 		dataIndex: ["uuid", "name", "is_enabled"],
	// 		key: "uuid",
	// 		render: (_, row) => {
	// 			return !props.viewOnly ? (
	// 				<div style={{ width: "16px" }}>
	// 					<Dropdown
	// 						placement={"bottomLeft"}
	// 						onClick={(e) => {
	// 							e.stopPropagation();
	// 						}}
	// 						style={{ marginLeft: "0" }}
	// 						overlay={
	// 							<Menu>
	// 								<Menu.Item
	// 									onClick={async (e) => {
	// 										e.domEvent.stopPropagation();
	// 										const address = await getAddress(row.location.latitude, row.location.longitude);
	// 										setpreviewDetails({
	// 											uid: row.uuid,
	// 											status: "done",
	// 											url: row.image.url_original,
	// 										});
	// 										// debugger;
	// 										setStoreDeatils({
	// 											...storeDetails,
	// 											name: row.name,
	// 											uuid: row.uuid,
	// 											company_code: row.company_code,
	// 											sap_code: row.sap_code,
	// 											location: JSON.stringify(row.location),
	// 											language: row.language,
	// 										});
	// 										setStorelocation({
	// 											...storelocation,
	// 											address: row.location?.address,
	// 											latitude: row.location?.latitude,
	// 											longitude: row.location?.longitude,
	// 											region: row.location?.region || row.location?.state || row.location?.country || "",
	// 											city: row.location?.city || "",
	// 											country: row.location?.country_name || JSON.parse(localStorage.getItem("countryData"))?.country_name,
	// 										});
	// 										setStoreImageFile(row.image);
	// 										setUpdateModal(true);
	// 									}}>
	// 									<Text style={{ color: "#181818" }}>Edit Store</Text>
	// 								</Menu.Item>

	// 								<Menu.Item
	// 									onClick={(e) => {
	// 										e.domEvent.stopPropagation();

	// 										setdisableStore(row);
	// 										setDisableModal(true);
	// 									}}>
	// 									<Text style={{ color: "#181818" }}>{row.is_enabled ? "Disable Store" : "Enable Store"}</Text>
	// 								</Menu.Item>
	// 							</Menu>
	// 						}>
	// 						<Icon
	// 							type="more"
	// 							onClick={(e) => {
	// 								e.stopPropagation();
	// 							}}
	// 							style={{
	// 								fontSize: "16px",
	// 								color: "#747474",
	// 								marginLeft: "52px",
	// 							}}
	// 						/>
	// 					</Dropdown>
	// 				</div>
	// 			) : (
	// 				<></>
	// 			);
	// 		},
	// 	},
	// ];


	const saveOrdering = (sortedItems) => {
		let tempSectionsList = [];
		sortedItems.map((kvp) => tempSectionsList.push(kvp.uuid));
		axios
			.post(
				`${serverUrl}/${JSON.parse(localStorage.getItem("countryData")).database_identifier
				}/store/reorder-store-list/`,
				{
					store_list: tempSectionsList,
					permission_category: ["STORE_CONTROL_CENTER"]
				},
				{
					headers: {
						"Content-Type": "application/json",
						Authorization: `JWT ${localStorage.getItem("token")}`,
					},
				}
			)
			.then((response) => {
				if (response.data.status === 200) {
					message.success("Orders applied Successfully!");
					// this.setState({ saveOrderInProgress: false });
				} else if (response.data.status === 405) {
					message.info("You are not authorised!");
				} else {
					message.error("Something went wrong!");
				}
			});
	};

	const onSortEnd = ({ oldIndex, newIndex }) => {
		const sortedItems = arrayMove(stores, oldIndex, newIndex)
		setStores(sortedItems)
		setTimeout(() => { saveOrdering(sortedItems) }, 100);
	};
	const SortableItem = SortableElement((props) => (
		<Row
			// gutter={[24, 24]}
			className='categoriescontainer'
			// style={{
			// 	//  backgroundColor: props.bgColor ? "#EAF4EC" : "#fff" 
			// }}
			display={"flex"}
			style={{
				margin: "10px 0px",
				cursor: "move",
				padding: "15px",
				borderBottom: "1px solid #E8E8E8",
				flexDirection: "row",
				background: "#ffffff"
			}}
		key={props.key}
		>
			<Col span={1}>
				<Icon type='menu' />
			</Col>
			<Col span={7}>
				{/* <Text className='table-listings-value-dark'>{props?.value?.name}</Text> */}
				<div
					style={{
						// width: "300px",
						display: "flex",
						//   justifyContent: "center",
						marginRight: "0px",
					}}>
					<img
						style={{
							height: "70px",
							width: "70px",
							borderRadius: "10px",
							marginRight: "15px",
						}}
						src={props?.value?.image?.url}></img>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
						}}>
						<Text
							style={{
								fontStyle: "normal",
								fontWeight: "bold",
								fontSize: "16px",
								lineHeight: "24px",
								color: "#181818",
								// whiteSpace: "nowrap",
								//   overflow: "scroll",
							}}>
							{props?.value?.store_details?.English?.name}
						</Text>
						<Text>{props?.value?.store_details?.English?.location?.address}</Text>
					</div>
				</div>
			</Col>
			{/* <Col span={1}></Col> */}
			<Col style={{ textAlign: "center" }} span={3}>
				<Text
					style={{
						whiteSpace: "nowrap",
					}}>
					{props?.value?.company_code}
				</Text>
			</Col>
			<Col style={{ textAlign: "center" }} span={2}>
				<Text
					style={{
						whiteSpace: "nowrap",
					}}>
					{props?.value?.sap_code}
				</Text>
			</Col>
			<Col style={{ textAlign: "center" }} span={2}>
				<Text
					style={{
						whiteSpace: "nowrap",
					}}>
					{props?.value?.store_details?.English?.location?.city}
				</Text>
			</Col>
			<Col style={{ textAlign: "center" }} span={4}>
				<Text
					style={{
						whiteSpace: "nowrap",
					}}>
					{props?.value?.store_details?.English?.location?.region}
				</Text>
			</Col>

			{/* <Col span={2}>
				<div>
					<ReactCountryFlag
						countryCode={getCountryFlag(props?.value?.country || JSON.parse(localStorage.getItem("countryData")).country_name)}
						svg
						title={props?.value?.country || localStorage.getItem("countryData").country_name}
						style={{
							height: "23px",
							width: "23px",
							borderRadius: "20px",
							backgroundColor: "black",
							objectFit: "cover",
							marginRight: "5px",
						}}
					/>
					<Text
						style={{
							whiteSpace: "nowrap",
						}}>
						{props?.value?.country || JSON.parse(localStorage.getItem("countryData")).country_name}
					</Text>
				</div>
			</Col> */}
			{/* <Col span={4}>
				<Select
				onClick={(e) => {
					e.stopPropagation();
				}}
					className={"time-value-cohort-col-main-element"}
					value={selectedLanguage || "default"}
					style={{
						width: "100%",
						marginTop: "8px",
					}}
					// disabled={selectedLanguage.uuid && activeKey === "sent" ? true : false}
					placeholder='Select Language from dropdown'
					onChange={(value) => {
						setSelectedLanguage(value);
					}}>
					<Option value='default'>English</Option>
					<Option value='promotion'>Arabic</Option>
					<Option value='profile'>Hindi</Option>
				</Select>
			</Col> */}
			<Col style={{ textAlign: "center" }} span={3}>
				<Text
					style={{
						whiteSpace: "nowrap",
					}}>
					{props?.value?.store_details?.English?.language}
				</Text>
			</Col>
			{/* <Col
				onClick={(e) => {
					e.stopPropagation();
				}}
				span={4}>
				<Select
					value={selectedLanguage}
					onSelect={(value) => {
						setSelectedLanguage(value);
					}}
					style={{
						border: "1px solid #D9D9D9",
						boxSizing: "border-box",
						borderRadius: "5px",
						backgroundColor: "#FFFFFF",
						width: "100%",
						// marginRight: "8px",
						display: "flex",
						alignItems: "center",
						// justifyContent: "space-between"
					}}>
					{languages.map((value) => (
						<Option key={value.uuid} value="">{value.name}</Option>
					))}
				</Select>
			</Col> */}
			<Col span={1}>
				<div style={{ width: "16px" }}>
					<Dropdown
						placement={"bottomLeft"}
						onClick={(e) => {
							e.stopPropagation();
						}}
						style={{ marginLeft: "0" }}
						overlay={
							<Menu>
								<Menu.Item
									onClick={async (e) => {
										e.domEvent.stopPropagation();
										const address = await getAddress(props?.value?.store_details?.English?.location.latitude, props?.value?.store_details?.English?.location.longitude);
										setpreviewDetails({
											uid: props?.value?.uuid,
											status: "done",
											url: props?.value?.image.url_original,
										});
										// debugger;
										setStoreDeatils({
											...storeDetails,
											name: props?.value?.name,
											uuid: props?.value?.uuid,
											store_details: props?.value?.store_details,
											// company_code: props?.value?.company_code,
											// sap_code: props?.value?.sap_code,
											// location: JSON.stringify(props?.value?.location),
											// language: props?.value?.language,
										});
										setStoreMainDeatils({
											...storeMainDetails,
											// name: props?.value?.name,
											uuid: props?.value?.uuid,
											// store_details: props?.value?.store_details,
											company_code: props?.value?.company_code,
											sap_code: props?.value?.sap_code,
											// location: JSON.stringify(props?.value?.location),
											// language: props?.value?.language,
										});
										setStorelocation({
											...storelocation,
											address: props?.value?.store_details[selectedLanguage].location?.address,
											latitude: props?.value?.store_details[selectedLanguage]?.location?.latitude,
											longitude: props?.value?.store_details[selectedLanguage]?.location?.longitude,
											region: props?.value?.store_details[selectedLanguage]?.location?.region || props?.value?.store_details[selectedLanguage]?.location?.state || props?.value?.store_details[selectedLanguage]?.location?.country || "",
											city: props?.value?.store_details[selectedLanguage]?.location?.city || "",
											country: props?.value?.store_details[selectedLanguage]?.location?.country_name || JSON.parse(localStorage.getItem("countryData"))?.country_name,
										});
										setStoreImageFile(props?.value?.image);
										setUpdateModal(true);
									}}>
									<Text style={{ color: "#181818" }}>Edit Store</Text>
								</Menu.Item>

								<Menu.Item
									onClick={(e) => {
										e.domEvent.stopPropagation();

										setdisableStore(props?.value);
										setDisableModal(true);
									}}>
									<Text style={{ color: "#181818" }}>{props?.value?.is_enabled ? "Disable Store" : "Enable Store"}</Text>
								</Menu.Item>
							</Menu>
						}>
						<Icon
							type="more"
							onClick={(e) => {
								e.stopPropagation();
							}}
							style={{
								fontSize: "16px",
								color: "#747474",
								marginLeft: "52px",
							}}
						/>
					</Dropdown>
				</div>
			</Col>
		</Row>
	));

	const SortableList = SortableContainer((props) => {
		return (
			<ul className='row wrapper-ul-row'>
				{" "}
				{stores.map((value, index) => (
					<Row
						key={index}
						onClick={() => {
							props.setActiveIndex(index);
						}}
					>
						<SortableItem
							bgColor={props.activeIndex === index ? true : false}
							key={`item-${value.uuid}`}
							index={index}
							sortIndex={index}
							value={value}
						/>
					</Row>
				))}
			</ul>
		);
	});

	const ListHeader = () => {
		return (
			<Row
				style={{
					marginBottom: "4px",
					padding: "15px",
					borderRadius: "5px",
					border: "1px solid #F2F2F2",
					backgroundColor: "#F2F2F2",
				}}>
				<Col span={8}>
					<Text className='header-text' style={{ marginLeft: "22px" }}>
						Store Name
					</Text>
				</Col>
				<Col style={{ textAlign: 'center' }} span={3}>
					<Text className='header-text'>
						Company Code
					</Text>
				</Col>
				<Col style={{ textAlign: "center" }} span={2}>
					<Text
						className='header-text'
					// style={{marginLeft: '20px'}}
					>
						Sap Code
					</Text>
				</Col>
				<Col style={{ textAlign: "center" }} span={2}>
					<Text className='header-text'>City</Text>
				</Col>
				<Col style={{ textAlign: 'center' }} span={4}>
					<Text className='header-text'>State/ Region/ Emirate</Text>
				</Col>
				{/* <Col span={2}>
					<Text className='header-text'>Country</Text>
				</Col> */}
				<Col style={{ textAlign: "center" }} span={3}>
					<Text className='header-text'>Language</Text>
				</Col>
			</Row>
		);
	};

	return (
		<>
			{/* <Table
				// rowSelection={props.noAction ? null : rowSelection}
				columns={(function () {
					// console.log(columns);
					// if (props.noAction) {
					// 	return columns.filter((item) => item.key != "x");
					// }
					// console.log(data);
					return columns;
				})()}
				dataSource={data?.stores?.map((item) => ({ ...item, key: item.uuid }))}
				pagination={props.noPagination ? false : { showQuickJumper: true, pageSize: data.pageSize ?? 10 }}
				style={{ overflow: "none" }}
				onChange={(pagination) => {
					props.updatePage(pagination.current);
				}}
				// onRow={(obj) => ({
				//   onClick: () => {
				//     props.history.push(`${props.location?.pathname}/${obj?.uuid}`);
				//   },
				// })}
				loading={props.loading}
			/> */}
			<ListHeader />

			<SortableList
				items={data?.stores}
				onSortEnd={onSortEnd}
				activeIndex={activeIndex}
				setActiveIndex={setActiveIndex}
			/>

			<Modal centered visible={disableModal} destroyOnClose maskClosable={false} onCancel={() => setDisableModal(false)} footer={null}>
				<Row className="modal-row">
					<Row>
						<Icon
							type="delete"
							style={{
								color: "#181818",
								fontSize: "24px",
								marginRight: "16px",
							}}
						/>
						<Text
							style={{
								fontWeight: "bold",
								color: "#181818",
								fontSize: "24px",
							}}>
							{disableStore.is_enabled ? "Disable" : "Enable"} Store
						</Text>
					</Row>
					<Row style={{ marginTop: "24px" }}>
						<Col span={24}>
							<Text>{`Are you sure you want to ${disableStore.is_enabled ? "disable" : "enable"} this Store?`}</Text>
						</Col>
						<Col
							style={{
								marginTop: "60px",
								textAlign: "right",
							}}
							span={18}>
							<Button
								size="large"
								style={{
									height: "40px",
									boxShadow: "none",
									borderRadius: "20px",
									border: "none",
									backgroundColor: "#FFFFFF",
									color: "#181818",
								}}
								onClick={() => setDisableModal(false)}>
								Cancel
							</Button>
						</Col>
						<Col
							style={{
								marginTop: "60px",
								textAlign: "right",
							}}
							span={6}>
							<Button
								size="large"
								style={{
									height: "40px",
									borderRadius: "2px",
									border: "none",
									backgroundColor: `${disableStore.is_enabled ? "#C91713" : "#fec708"}`,
									color: "#FFFFFF",
								}}
								onClick={() => {
									updateStoreApi({
										requestData: {
											uuid: disableStore.uuid,
											is_enabled: !disableStore.is_enabled,
											permission_category: ["STORE_CONTROL_CENTER"],
										},
										res200Callback: () => {
											setDisableModal(false);
											props.loadTable();
											// props.updatePage(data.pageNum);
										},
									});
								}}>
								{disableStore.is_enabled ? "Disable" : "Enable"}
							</Button>
						</Col>
					</Row>
				</Row>
			</Modal>

			<Modal
				centered
				visible={updateModal}
				destroyOnClose
				maskClosable={false}
				onCancel={() => {
					setUpdateModal(false);
					props.loadTable();
				}}
				footer={null}
				width={700}>
				<Row className="modal-row">
					<Row>
						<div style={{ display: "flex" }}>
							<div>
								<StoreLogo style={{ marginTop: "2px" }} />
							</div>
							<Text
								style={{
									// marginTop: "24px",
									marginLeft: "16px",
									fontWeight: "700",
									color: "#181818",
									fontSize: "24px",
									// fontFamily: "Gotham",
									fontStyle: "normal",
									lineHeight: "40px",
								}}>
								Edit a Store
							</Text>
						</div>
					</Row>
					<div style={{ margin: "16px 0px", background: "#E8E8E8", height: "1px" }}></div>

					<Row style={{ marginTop: "16px" }}>
						<div>
							<Menu
								selectedKeys={selectedLanguage}
								onSelect={(e) => setSelectedLanguage(e.key)}
								mode="horizontal"
								style={{ backgroundColor: "transparent" }}>
								{languagesData.map((value) => {
									return (
										<Menu.Item key={value}>
											{value}
										</Menu.Item>
									);
								})}
							</Menu>
							<div style={{
								marginTop: "32px",
								//   display: "flex",
							}}>
								<Text
									style={{
										fontSize: "14px",
										color: "#181818",
										fontWeight: "bold",
										// fontWeight:"bold"
									}}>
									Store Name
								</Text>
								<Input
									className="time-value-cohort-col-main-element"
									style={{ width: "100%", marginTop: "4px" }}
									placeholder="Enter store name"
									onChange={(event) => {
										setLanguageSpecificStoreInfo(event.target.name, event.target.value)
									}}
									name="name"
									value={storeDetails?.store_details[selectedLanguage]?.name}
								/>
							</div>
							<div
								style={{
									marginTop: "32px",
									//   display: "flex",
								}}>
								<Text
									style={{
										fontSize: "14px",
										color: "#181818",
										fontWeight: "bold",
										// fontWeight:"bold"
									}}>
									Store Address
								</Text>
								<Input
									className="time-value-cohort-col-main-element"
									style={{ width: "100%", marginTop: "4px" }}
									placeholder="Enter store Address"
									// onChange={(e) => {
									//   addStoreManually.current.name = e.target.value;
									// }}

									value={storeDetails?.store_details[selectedLanguage]?.location?.address}
									onChange={(event) => {
										setStorelocation({
											...storelocation,
											[event.target.name]: event.target.value,
										});
										setLanguageSpecificStoreLocation(event.target.name, event.target.value)
									}}
									name="address"
								/>
							</div>

							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
								}}>
								<div
									style={{
										marginTop: "32px",
										width: "49%",
										// display: "flex",
									}}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
											// fontWeight:"bold"
										}}>
										Latitude
									</Text>
									<Input
										className="time-value-cohort-col-main-element"
										style={{ width: "100%", marginTop: "4px" }}
										placeholder="Enter the Latitude"
										// onChange={(e) => {
										//   addStoreManually.current.name = e.target.value;
										// }}

										value={storeDetails?.store_details[selectedLanguage]?.location?.latitude}
										onChange={(event) => {
											// setStorelocation({
											// 	...storelocation,
											// 	[event.target.name]: event.target.value,
											// });
											let location = {
												...storeDetails?.store_details[selectedLanguage]?.location,
												[event.target.name]: event.target.value,
											}
											setLanguageSpecificStoreLocation(event.target.name, event.target.value)
											getlocation(location);
										}}
										name="latitude"
									/>
								</div>
								<div
									style={{
										marginTop: "32px",
										width: "49%",
									}}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
											// fontWeight:"bold"
										}}>
										Longitude
									</Text>
									<Input
										className="time-value-cohort-col-main-element"
										style={{ width: "100%", marginTop: "4px" }}
										placeholder="Enter the Longitude"
										value={storeDetails?.store_details[selectedLanguage]?.location?.longitude}
										onChange={(event) => {
											// setStorelocation({
											// 	...storelocation,
											// 	[event.target.name]: event.target.value,
											// });
											let location = {
												...storeDetails?.store_details[selectedLanguage]?.location,
												[event.target.name]: event.target.value,
											}
											setLanguageSpecificStoreLocation(event.target.name, event.target.value)
											getlocation(location);
										}}
										name="longitude"
									/>
								</div>
							</div>
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
								}}>

								<div
									style={{
										marginTop: "32px",
										width: "100%",
									}}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
											// fontWeight:"bold"
										}}>
										Country
									</Text>
									<Select
										defaultValue={"United Arab Emirates"}
										className="time-value-cohort-col-main-element"
										style={{ width: "100%", marginTop: "4px" }}
										placeholder="Choose a Country"
										name="country"
										value={storeDetails?.store_details[selectedLanguage]?.location?.country}
										onChange={(value) => {
											setStorelocation({
												...storelocation,
												["country"]: value,
											});
											setLanguageSpecificStoreLocation("country", value)
										}}>
										{countries.map((country) => {
											return (
												<Option key={country.name} value={country.name}>
													<ReactCountryFlag
														countryCode={getCountryFlag(country.name || JSON.parse(localStorage.getItem("countryData"))?.country_name)}
														svg
														title={country.name}
														style={{
															height: "20px",
															width: "20px",
															borderRadius: "20px",
															backgroundColor: "black",
															objectFit: "cover",
															marginRight: "5px",
															marginTop: "4px",
														}}
													/>
													{country.name}
												</Option>
											);
										})}
									</Select>
								</div>
								{/* <div
									style={{
										marginTop: "32px",
										width: "49%",
									}}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
											// fontWeight:"bold"
										}}>
										Language
									</Text>
									<Select
										// defaultValue={"English"}
										className="time-value-cohort-col-main-element"
										style={{ width: "100%", marginTop: "4px" }}
										placeholder="Choose a Language"
										name="language"
										value={storeDetails.language}
										onSelect={(event) => {
											setStoreDeatils({
												...storeDetails,
												language: event,
											});
										}}>
										{languagesData.map((value) => {
											return (
												<Option key={value} value={value}>
													{value}
												</Option>
											);
										})}
									</Select>
								</div> */}
							</div>
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
								}}>
								<div
									style={{
										marginTop: "32px",
										width: "49%",
										// display: "flex",
									}}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
											// fontWeight:"bold"
										}}>
										State/Region/Emirate
									</Text>
									<Input
										className="time-value-cohort-col-main-element"
										style={{ width: "100%", marginTop: "4px" }}
										placeholder="Enter a region"
										name="region"
										value={storeDetails?.store_details[selectedLanguage]?.location?.region}
										onChange={(event) => {
											setStorelocation({
												...storelocation,
												[event.target.name]: event.target.value,
											});
											setLanguageSpecificStoreLocation(event.target.name, event.target.value)
										}}></Input>
								</div>
								<div
									style={{
										marginTop: "32px",
										width: "49%",
										// display: "flex",
									}}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
											// fontWeight:"bold"
										}}>
										City
									</Text>
									<Input
										className="time-value-cohort-col-main-element"
										style={{ width: "100%", marginTop: "4px" }}
										placeholder="Enter a city"
										name="city"
										// style={{ width: "4px" }}
										value={storeDetails?.store_details[selectedLanguage]?.location?.city}
										onChange={(event) => {
											setStorelocation({
												...storelocation,
												[event.target.name]: event.target.value,
											});
											setLanguageSpecificStoreLocation(event.target.name, event.target.value)
										}}></Input>
								</div>
							</div>
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
								}}>
								<div
									style={{
										marginTop: "32px",
										width: "49%",
										// display: "flex",
									}}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
											// fontWeight:"bold"
										}}>
										Company Code
									</Text>
									<Input
										className="time-value-cohort-col-main-element"
										style={{ width: "100%", marginTop: "4px" }}
										placeholder="Enter a Country Code"
										name="company_code"
										value={storeMainDetails.company_code}
										onChange={(event) => {
											setStoreMainDeatils({
												...storeMainDetails,
												[event.target.name]: event.target.value,
											});
										}}></Input>
								</div>
								<div
									style={{
										marginTop: "32px",
										width: "49%",
										// display: "flex",
									}}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
											// fontWeight:"bold"
										}}>
										Sap Code
									</Text>
									<Input
										className="time-value-cohort-col-main-element"
										style={{ width: "100%", marginTop: "4px" }}
										placeholder="Enter a Sap Code"
										name="sap_code"
										// style={{ width: "4px" }}
										value={storeMainDetails.sap_code}
										onChange={(event) => {
											setStoreMainDeatils({
												...storeMainDetails,
												[event.target.name]: event.target.value,
											});
										}}></Input>
								</div>
							</div>
							<Row className="image-upload-row" style={{ marginTop: "32px" }}>
								{/*//this.state.promoUuid != "" &&*/}
								<React.Fragment>
									<Col span={24} className="image-upload-col">
										<Text
											style={{
												fontSize: "14px",
												color: "#181818",
												fontWeight: "bold",
											}}>
											Upload Store Image
										</Text>
										<br />
										<Text style={{ fontSize: "12px", marginTop: "4px" }}>
											Allowed image format is JPG, JPEG, PNG and size 100x100 upto 20KB - 40KB
										</Text>
										<div
											style={{
												marginTop: "4px",
												width: "650px",
												border: "1px solid rgb(0, 0, 0, 0.25)",
												borderRadius: "5px",
												background: "transparent",
											}}
											className="image-upload-container">
											<Upload
												className={StoreImageFile === null ? "upload-class" : "upload-class-none"}
												name="file"
												listType={"picture-card"}
												beforeUpload={(file) => {
													const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
													if (!isJpgOrPng) {
														message.error("You can only upload JPG/PNG file!");
													}
													const isLt2M = file.size / 1024 / 1024 < 2;
													if (!isLt2M) {
														message.error("Image must smaller than 2MB!");
													}
													return isJpgOrPng && isLt2M;
												}}
												onRemove={() => {
													setStoreImageFile(null);
												}}
												multiple={false}
												style={{
													marginTop: "8px",
													width: "100%",
													border: "1px solid rgb(0, 0, 0, 0.25)",
													borderRadius: "5px",
													background: "transparent",
												}}
												// bordered={true}
												showUploadList={{
													showPreviewIcon: false,
												}}
												customRequest={({ file, onSuccess }) => {
													setTimeout(() => {
														onSuccess("ok");
													}, 0);
												}}
												onChange={(info) => {
													const { status } = info.file;
													if (status === "done") {
														if (info.fileList.length >= 2) info.fileList.shift();
														// console.log(info);

														setStoreImageFile(info.fileList[0]?.originFileObj);
													} else if (status === "error") {
														message.error(`${info.file.name} file upload failed.`);
													} else if (status === "removed") {
														setStoreImageFile(null);
													} else if (!status) {
														info.fileList.pop();
													}
												}}
												defaultFileList={[
													{
														...previewDetails,
													},
												]}
											// data={StoreImageFile}
											>
												{StoreImageFile == null ? (
													<>
														<Row type="flex" justify="center" align="middle" style={{ flexDirection: "column" }}>
															<Icon
																type="cloud-upload"
																style={{
																	color: "#E5E5E5",
																	fontSize: "48px",
																	marginTop: "25px",
																	marginBottom: "24px",
																}}
															/>
															<Text
																style={{
																	fontStyle: "normal",
																	fontWeight: "normal",
																	fontSize: "14px",
																	lineHeight: "22px",
																	color: "#181818",
																	marginBottom: 8,
																}}>
																Drag & drop file or browse image to upload
															</Text>
														</Row>
													</>
												) : (
													<></>
												)}
											</Upload>
										</div>
									</Col>
								</React.Fragment>
							</Row>
						</div>
						<div
							style={{
								marginTop: "24px",
								background: "#E8E8E8",
								height: "1px",
							}}></div>
						<Row
							type="flex"
							justify="end"
							align="middle"
							style={{
								marginTop: "32px",
							}}>
							<Button
								size="large"
								style={{
									height: "32px",
									boxShadow: "none",
									borderRadius: "20px",
									border: "none",
									backgroundColor: "#FFFFFF",
									color: "#181818",
									marginRight: "12px",
								}}
								onClick={() => {
									props.loadTable();
									setUpdateModal(false);
								}}>
								Cancel
							</Button>
							<Button
								size="large"
								style={{
									// height: "32px",
									borderRadius: "5px",
									border: "none",
									backgroundColor: "#fec708",
									color: "#FFFFFF",
								}}
								onClick={() => {
									updateStore(storeDetails, setStoreDeatils, storelocation, StoreImageFile, setUpdateModal, props.loadTable, storeMainDetails).then(() => { });
								}}>
								Update Store
							</Button>
						</Row>
					</Row>
				</Row>
			</Modal>
		</>
	);
};

export default StoresTable;
